<template>
  <div>
    <q-select
      v-model="model"
      use-input
      input-debounce="0"
      label="Assign User"
      option-label="email"
      option-value="id"
      :emit-value="true"
      map-options
      :loading="usersLoading"
      :options="options"
      @filter="filterFn"
      @input="$emit('changed', model)"
    >
      <template v-slot:no-option>
        <q-item>
          <q-item-section class="text-grey"> No results </q-item-section>
        </q-item>
      </template>
    </q-select>
  </div>
</template>

<script>
  import { mapGetters } from "vuex";

  export default {
    props: {
      id: {
        type: Number,
        default: null,
      },
    },
    computed: {
      ...mapGetters({
        currentUser: "auth/currentUser",
        users: "users/list",
        usersLoading: "users/listLoading",
      }),
    },
    watch: {
      id: function () {
        this.init();
      },
      users: function () {
        this.init();
      },
    },
    data: () => ({
      model: null,
      options: [],
    }),
    mounted() {
      this.init();
    },
    methods: {
      init() {
        this.options = JSON.parse(JSON.stringify(this.users));
        this.model = this.id;
      },
      filterFn(val, update) {
        if (val === "") {
          update(() => {
            this.options = JSON.parse(JSON.stringify(this.users));
          });
          return;
        } else {
          update(() => {
            const needle = val.toLowerCase();
            this.options = this.users.filter(
              (v) => v.name.toLowerCase().indexOf(needle) > -1
            );
          });
        }
      },
    },
  };
</script>
